import { ADD_USER, RECEIVE_USER } from '../actions/users';

export default function users(state = {}, action) {
  switch (action.type) {
    case RECEIVE_USER:
      return {
        ...state,
        ...action.users,
      };
    case ADD_USER:
      let objectId = Math.max(Object.keys(state));
      if (Object.keys(state).length === 0) {
        objectId = 0;
      } else {
        objectId = objectId + 1;
      }
      return {
        ...state,
        [objectId]: {
          _id: action.email,
          email: action.email,
          name: action.name,
          password: action.password,
        },
      };
    default:
      return state;
  }
}
